import React, {Component} from 'react';
import GlobalVariable from '../../GlobalVariable';
import api from '../../api';
import Menu from '../Menu';
import PageHeader from '../PageHeader';
import Preloader from '../Preloader';

class Vacancies extends Component<any, any> {
    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            isLoad: false,
            currentCity: '',
            items: [],
            error: '',
        };
    }

    componentDidMount() {
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/vacancies',
            method: 'GET',
            withCredentials: true,
            headers: {'Content-Type': 'application/json'},
        }).then((result) => {
            this.setState({
                isLoad: true,
                currentCity: result.data?.currentCity || '',
                items: result.data?.items || [],
                error: '',
            });
        }).catch((error) => {
            if (error?.response?.status === 401) {
                window.location.href = '/start';
                return;
            }
            this.setState({isLoad: true, error: 'Не удалось загрузить вакансии'});
        });
    }

    money(value: any) {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        return `${Number(value || 0).toLocaleString('ru-RU')} ₽`;
    }

    render() {
        if (!this.state.isLoad) {
            return <Preloader/>;
        }

        return (
            <div className='main vacancies'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Вакансии' backBtnUrl='/'/>
                    <div className='pt-header'></div>

                    {this.state.error ? (
                        <div className='chio-card ml-3 mr-3 mt-3 p-3 txt-middle'>{this.state.error}</div>
                    ) : null}

                    {!this.state.error && this.state.items.length === 0 ? (
                        <div className='chio-card ml-3 mr-3 mt-3 p-3 txt-middle'>
                            Вакансий в других городах пока нет
                        </div>
                    ) : null}

                    {this.state.items.map((item: any) => (
                        <div className='chio-card ml-3 mr-3 mt-3 p-3' key={item.id || item.externalId}>
                            <div className='txt-large bold mb-1'>{item.title}</div>
                            <div className='txt-middle mb-2'>{item.city}, {item.address}</div>
                            {item.schedule ? <div className='txt-middle'>График: {item.schedule}</div> : null}
                            {item.guaranteedIncome ? <div className='txt-middle'>Доход в смену: {this.money(item.guaranteedIncome)}</div> : null}
                            {item.revenuePercent ? <div className='txt-middle'>Процент: {item.revenuePercent}%</div> : null}
                            {item.requirements ? <div className='txt-middle mt-2'>{item.requirements}</div> : null}
                            {item.contact ? <div className='txt-middle mt-2 bold'>{item.contact}</div> : null}
                        </div>
                    ))}
                </div>
                <Menu/>
            </div>
        );
    }
}

export default Vacancies;
